import { CanActivateFn, Router } from '@angular/router';
import { App } from '../../../shared/services/app/app';
import { inject } from '@angular/core';
import { NavigationFeedbackService } from '../../services/navigation-feedback/navigation-feedback';

export const processGuard: CanActivateFn = (route, state) => {

  const appService = inject(App);
  const router = inject(Router);
  const feedback = inject(NavigationFeedbackService);

  if(!appService.getProcess()){
    feedback.notify('Upload files first');
    router.navigate(['home']);
    return false;
  }  
  return true;
};
